import type { Event } from './admin';

export interface Reservation {
  id: string;
  eventId: string;
  eventTitle: string;
  buyer: string;
  tickets: number;
  total: number;
  status: 'confirmed' | 'cancelled' | 'pending';
  date: string;
  ticketCode: string;
  email: string;
  phone: string;
  address?: string;
}

export const ORGANIZER_EVENTS: Event[] = [
  {
    id: 'oe1', title: 'AfroFest 2026 – Grand Concert', type: 'Concert',
    date: '2026-05-15T20:00:00', endDate: '2026-05-16T02:00:00',
    location: 'Stade Omnisports de Yaoundé', description: 'Le plus grand festival de musique afrobeat d\'Afrique Centrale. Plus de 20 artistes internationaux sur scène.',
    ticketPrice: 5000, totalSeats: 5000, soldSeats: 1240,
    status: 'pending', organizerId: 'org-1', organizerName: 'Jean-Pierre Nkosi',
    image: 'https://readdy.ai/api/search-image?query=afrobeat%20concert%20festival%20stage%20lights%20crowd%20night%20africa%20music%20event%20vibrant%20colorful%20atmosphere&width=400&height=250&seq=oe1&orientation=landscape',
    createdAt: '2026-03-30T10:00:00', contact: '+237 699 123 456',
  },
  {
    id: 'oe2', title: 'Night Jazz & Soul Douala', type: 'Concert',
    date: '2026-04-25T21:00:00', endDate: '2026-04-26T01:00:00',
    location: 'Restaurant Le Grill, Douala', description: 'Une soirée intimiste de jazz et soul avec les meilleurs musiciens locaux. Repas gastronomique inclus.',
    ticketPrice: 20000, totalSeats: 80, soldSeats: 62,
    status: 'approved', organizerId: 'org-1', organizerName: 'Jean-Pierre Nkosi',
    image: 'https://readdy.ai/api/search-image?query=jazz%20night%20concert%20intimate%20restaurant%20elegant%20lighting%20musicians%20saxophone%20piano%20atmosphere&width=400&height=250&seq=oe2&orientation=landscape',
    createdAt: '2026-03-15T09:00:00', contact: '+237 699 123 456',
  },
  {
    id: 'oe3', title: 'Expo Art Contemporain Africain', type: 'Exposition',
    date: '2026-04-08T10:00:00', endDate: '2026-04-14T18:00:00',
    location: 'Galerie Nationale, Douala', description: 'Exposition de 30 artistes contemporains africains. Peintures, sculptures, installations numériques. Vernissage le 8 avril.',
    ticketPrice: 2000, totalSeats: 1500, soldSeats: 340,
    status: 'approved', organizerId: 'org-1', organizerName: 'Jean-Pierre Nkosi',
    image: 'https://readdy.ai/api/search-image?query=african%20contemporary%20art%20exhibition%20gallery%20paintings%20sculptures%20colorful%20modern%20museum%20space&width=400&height=250&seq=oe3&orientation=landscape',
    createdAt: '2026-03-10T11:00:00', contact: '+237 699 123 456',
  },
];

export const ORGANIZER_RESERVATIONS: Reservation[] = [
  { id: 'r1', eventId: 'oe2', eventTitle: 'Night Jazz & Soul Douala', buyer: 'Élodie Mbarga', tickets: 2, total: 40000, status: 'confirmed', date: '2026-03-29T19:30:00', ticketCode: 'TK-NJ-2026-001', email: 'elodie@mail.cm', phone: '+237 677 123 456' },
  { id: 'r2', eventId: 'oe2', eventTitle: 'Night Jazz & Soul Douala', buyer: 'Patrick Essame', tickets: 1, total: 20000, status: 'confirmed', date: '2026-03-30T10:15:00', ticketCode: 'TK-NJ-2026-002', email: 'patrick@mail.cm', phone: '+237 655 234 567' },
  { id: 'r3', eventId: 'oe3', eventTitle: 'Expo Art Contemporain', buyer: 'Laure Nkemba', tickets: 3, total: 6000, status: 'confirmed', date: '2026-03-31T14:00:00', ticketCode: 'TK-EX-2026-001', email: 'laure@art.cm', phone: '+237 699 345 678' },
  { id: 'r4', eventId: 'oe2', eventTitle: 'Night Jazz & Soul Douala', buyer: 'Henri Bongo', tickets: 2, total: 40000, status: 'pending', date: '2026-04-01T08:00:00', ticketCode: 'TK-NJ-2026-003', email: 'henri@mail.cm', phone: '+237 622 456 789' },
  { id: 'r5', eventId: 'oe3', eventTitle: 'Expo Art Contemporain', buyer: 'Nadège Fouda', tickets: 1, total: 2000, status: 'confirmed', date: '2026-04-01T09:45:00', ticketCode: 'TK-EX-2026-002', email: 'nadege@mail.cm', phone: '+237 677 567 890' },
];

export const ORGANIZER_STATS = {
  totalEvents: 3, pendingEvents: 1, approvedEvents: 2, totalTicketsSold: 1642,
  totalRevenue: 2564000, monthlyRevenue: 420000, avgFillRate: 72,
};
